import * as React from 'react';

import { cn } from '@shared/lib/utils';

import type { IconProps } from './icon-types';

export function TrashIcon({ size = 20, className, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 23 27"
      fill="none"
      className={cn('shrink-0', className)}
      aria-hidden="true"
      {...props}
    >
      <g clipPath="url(#clip0_753_8392)">
        <path
          d="M21.15 4.53H16.67C16.36 1.69 14.31 0 11.02 0C7.73 0 5.69 1.68 5.38 4.53H0.9C0.4 4.53 0 4.93 0 5.43C0 5.93 0.4 6.33 0.9 6.33H1.44V25.52C1.44 26.02 1.84 26.42 2.34 26.42H19.71C20.21 26.42 20.61 26.02 20.61 25.52V6.33H21.15C21.65 6.33 22.05 5.93 22.05 5.43C22.05 4.93 21.65 4.53 21.15 4.53ZM11.03 1.8C13.29 1.8 14.6 2.74 14.88 4.52H7.17C7.45 2.73 8.77 1.8 11.02 1.8H11.03ZM18.82 24.62H3.24V6.33H18.81V24.62H18.82Z"
          fill="#05A2C7"
        />
        <path
          d="M15.5299 21.6499C16.0299 21.6499 16.4299 21.2499 16.4299 20.7499V9.71995C16.4299 9.21995 16.0299 8.81995 15.5299 8.81995C15.0299 8.81995 14.6299 9.21995 14.6299 9.71995V20.7499C14.6299 21.2499 15.0299 21.6499 15.5299 21.6499Z"
          fill="#05A2C7"
        />
        <path
          d="M11.0299 21.6499C11.5299 21.6499 11.9299 21.2499 11.9299 20.7499V9.71995C11.9299 9.21995 11.5299 8.81995 11.0299 8.81995C10.5299 8.81995 10.1299 9.21995 10.1299 9.71995V20.7499C10.1299 21.2499 10.5299 21.6499 11.0299 21.6499Z"
          fill="#05A2C7"
        />
        <path
          d="M6.52012 21.6499C7.02012 21.6499 7.42012 21.2499 7.42012 20.7499V9.71995C7.42012 9.21995 7.02012 8.81995 6.52012 8.81995C6.02012 8.81995 5.62012 9.21995 5.62012 9.71995V20.7499C5.62012 21.2499 6.02012 21.6499 6.52012 21.6499Z"
          fill="#05A2C7"
        />
      </g>
      <defs>
        <clipPath id="clip0_753_8392">
          <rect width="22.05" height="26.42" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
